module.exports = __webpack_public_path__ + "img/arrowdown.39f23c6d.svg";